import { Component } from '@angular/core';
import { GoogleSearchResultsService } from './google-search-results.service';

@Component({
    selector: 'google-search-results',
    providers: [GoogleSearchResultsService],
    templateUrl: './google-search-results.component.html',
})
export class GoogleSearchResultsComponent {
    public searchResults = [];
    searchText: String;
    pageNumber = 0;
    pagesServed = 0;
    loadingResults = false;

    constructor(private googleSearchResultsService: GoogleSearchResultsService) { }

    setSearchText(searchText) {
        this.searchText = searchText;
        this.searchResults = [];
        this.pageNumber = 0;
        this.pagesServed = 0;
    }

    loadData(event) {
        if (this.searchText && this.pageNumber <= this.pagesServed) {
            this.loadingResults = true;
            this.pageNumber += 1;
            this.googleSearchResultsService.fetchSearchResults(this.searchText, this.pageNumber)
                .subscribe(
                response => {
                    this.loadingResults = false;
                    var googleSearchData = response.arrResult;
                    if (googleSearchData.length == 1 && googleSearchData[0].title == 'No result found') {
                        return;
                    }
                    this.searchResults = this.searchResults.concat(googleSearchData);
                    this.pagesServed += 1;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/googlesearchresults/google-search-results.component.ts